export default {
    city: 'Ciudad',
    cityPlaceHolder: 'Selecciona una ciudad',
    noCity: 'Ciudad no encontrada',
    noCities: 'Ciudades no encontradas',
};
